// Library
import React, { ReactNode } from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";

const bem = new BemHelper("dashboard-stats-box");

type Props = {
  icon: ReactNode;
  title: string;
  value: number | string | ReactNode;
  mobile: boolean;
};

export const DashboardStatsBox: React.FC<Props> = ({ icon, title, value = 0, mobile }) => {
  return (
    <div className={classNames([bem.block(), mobile && bem.modifier("mobile")])}>
      <div className={classNames(bem.element("wrapper"))}>
        <div>{icon}</div>
        <div className={classNames([bem.element("content")])}>
          <div className={classNames(bem.element("title"))}>{title}</div>
          <div className={classNames(bem.element("value"))}>{value}</div>
        </div>
      </div>
    </div>
  );
};
